import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import {
	CommonReduxState,
	ISnackBarState,
	snackBarType,
} from "../types/common.types";

const initialState: CommonReduxState = {
	enableUploadButton: false,
	otpModalVisible: false,

	snackbarState: {
		isOpen: false,
		message: "",
		type: snackBarType.info,
	},
	storredUserData: {},
	product: "",
};

const commonSlice = createSlice({
	name: "commonData",
	initialState,
	reducers: {
		setEnableUploadButton: (state, action: PayloadAction<boolean>) => {
			state.enableUploadButton = action.payload;
		},
		setOtpModalVisible: (state, action: PayloadAction<boolean>) => {
			state.otpModalVisible = action.payload;
		},
		updateSnackbarState: (state, action: PayloadAction<ISnackBarState>) => {
			state.snackbarState = action.payload;
		},
		clearSnackbarState: (state) => {
			state.snackbarState = initialState.snackbarState;
		},
		setProductName: (state, action: PayloadAction<string>) => {
			state.product = action.payload;
		},

		setStorredUserData: (state, action: PayloadAction<Record<string, any>>) => {
			state.storredUserData = action.payload;
		},
	},
});

export const {
	setEnableUploadButton,
	setOtpModalVisible,
	updateSnackbarState,
	clearSnackbarState,
	setStorredUserData,
	setProductName,
} = commonSlice.actions;

export default commonSlice.reducer;
